class Pictogram {
  id!: number;
  reference!: string;
  label!: string;
  version!: number;
  file!: string;
}

export default Pictogram;
